// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav":"nav_h-xxy","tab":"tab_kPICC","tab_active":"tab_active_NWHhl"};